import React from 'react';
import { SectionList, View } from 'react-native';
import PropTypes from 'prop-types';
import { t } from 'Locale';
import { SectionListHeader, SectionListItem, sectionListStyles } from 'LocalGluons';
import { useStore } from 'Store';
import { getSettingsSections } from './settingsSections';
import ContentWrapper from '../ContentWrapper';

import baseStyles from './SettingsPage.jss';

const SettingsPage = ({ navigation }) => {
    const { userData, mCoreConfig, mySubscriptions } = useStore();
    const sections = getSettingsSections(
        userData,
        mCoreConfig.nativeConsentsEnabled,
        mySubscriptions.subscriberType
    );

    return (
        <SectionList
            style={[sectionListStyles.container, baseStyles.container]}
            renderItem={({ item }) => (
                <SectionListItem
                    key={item.title}
                    title={t(item.title)}
                    onPress={() => {
                        const { navigationOptions } = item;
                        if (!navigationOptions) {
                            return;
                        }
                        const { route, params } = navigationOptions;

                        if (route) {
                            navigation.navigate(route, params);
                        }
                    }}
                    testID={`${item.title}`}
                />
            )}
            renderSectionHeader={({ section: { title, data } }) =>
                data.length > 0 ? (
                    <View style={baseStyles.sectionHeader}>
                        <SectionListHeader title={t(title).toUpperCase()} />
                    </View>
                ) : null
            }
            sections={sections}
            keyExtractor={(item, index) => item + index}
            stickySectionHeadersEnabled={false}
        />
    );
};

SettingsPage.propTypes = {
    navigation: PropTypes.shape({
        navigate: PropTypes.func.isRequired
    }).isRequired
};

export default SettingsPage;
